export default __webpack_public_path__ + "static/media/pic30.6965bd5a.jpg";